export default __webpack_public_path__ + "static/media/bg_head2.5e70421f.jpg";